<template>
    <section v-if="hasPermissions(['Budgeting-Staffing-Fixed Read', 'Budgeting-Staffing-Fixed Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>

        <div class="view__description">
            <p class="view__description__text">
                Use the Wizard to add Rooms to the Fixed Data or click Add Fixed to create a new fixed line item.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="staffing_fixed.length && hasPermissions(['Budgeting-Staffing-Fixed Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <ul class="nav nav-tabs" v-if="staffing_fixed.length && hasPermissions(['Budgeting-Staffing-Fixed Read'])">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#listation"> <i class="fa fa-list"/> </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#cards-listation">  <i class="fa fa-th-large"/> </a>
                    </li>
                </ul>
            </div>
            <div v-if="hasPermissions(['Budgeting-Staffing-Fixed Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="staffing_fixed.length && hasPermissions(['Budgeting-Staffing-Fixed Read'])">
            <div class="tab-pane fade" id="cards-listation">
                <div class="row mb-0">
                    <div class="col-sm-6 col-lg-3" v-for="(value, i) in staffing_fixed" :key="i">
                        <div class="row mb-0 no-gutters h-100">
                            <div class="col-12 card cardList hoverable">
                                <div class="card-content h-100">
                                    <div class="card-title">
                                        <div class="row mb-0 no-gutters">
                                            <div class="col-10">
                                                <div v-if="has_permission('Budgeting-Staffing-Fixed Read-Write')">
                                                    <a href="#" @click="modal_update(i)" class="textTitleCard">
                                                        {{ `${i+1}. ${value.description}` }}
                                                    </a>
                                                </div>
                                                <div v-else>
                                                    <a href="#" class="textTitleCard">
                                                        {{ `${i+1}. ${value.name}` }}
                                                    </a>
                                                </div>
                                            </div>
                                            <div v-if="has_permission('Budgeting-Staffing-Fixed Read-Write')" class="col-2 text-right">
                                                <a href="#" @click="modal_deletion(i)">
                                                    <i class="material-icons prefix ">
                                                        <img class="iconCard" src="/assets/img/trash.png" alt="date">
                                                    </i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-0 no-gutters">
                                        <div class="col-12">
                                            <ul class="list">
                                                <li v-html="`S. Scenario: ${value.staffing_scenario}`" class="list__item"></li>
                                                <li v-html="`Description: ${value.description}`" class="list__item"></li>
                                                <li v-html="`Order #: ${value.order}`" class="list__item"></li>
                                                <li v-html="`Frequency/Week #: ${value.frequency_week}`" class="list__item"></li>
                                                <li v-html="`Daily Minutes #: ${value.daily_minutes}`" class="list__item"></li>
                                                <li v-html="`Annual Minutes #: ${value.annual_minutes}`" class="list__item"></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-action">
                                    <a :href="`${child_href}${value.id}`" class="card-action__link">
                                        View more
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <v-data-table
                                v-model="table_selection"
                                :headers="table_headers"
                                :items="staffing_fixed"
                                :search="search"
                                :single-select="single_select"
                                item-key="id"
                                show-select
                                class="elevation-1"
                            >
                                <template v-slot:[`item.scenario`]="{item}">
                                    <a :href="`/budgeting-staffing-scenario/${item.id}`" v-html="item.scenario"/>
                                </template>
                                <template v-slot:[`item.description`]="{item}">
                                    <a :href="`${child_href}${item.id}`" v-html="item.description"/>
                                </template>
                            </v-data-table>
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <FormModal 
            :title="'New Staffing Fixed'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Staffing Fixed Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

    </section>
</template>

<script>
import axios            from    'axios';
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import Resources        from    './resources'
import FormModal        from    './FormModal'
import UpdateModal      from    './UpdateModal'
import DeletionModal    from    '@/components/DeletionModal'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {
    name: 'StaffingFixed',

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        UpdateModal
    },

    data() {
        return {
            notyf,
            axios,
            child_href:         '/budgeting-staffing-fixed/',
            title_page:         'Staffing Fixed',
            content_header:     this.$store.state.headers,
            rest_api:           `staffing_fixed`,
            notifications:      this.$store.state.form_notyf,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            add_btn:            'Add Staffing Fixed',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       '',
            single_object:      {},
            staffing_fixed:     [],
            array_options:      {},
        }
    },

    methods: {
        
        unshift_object(new_object)
        {
            this.staffing_fixed.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.staffing_fixed.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.staffing_fixed[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.staffing_fixed[index]
            
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.staffing_fixed = data.staffing_fixed
            this.array_options = {
                staffing_scenario_id: data.staffing_scenarios,
                group_id: data.groups
            }
        },

        trashing(index)
        {
            this.staffing_fixed.splice(index, 1)
        }
        
    },

    async mounted()
    {
       if(this.hasPermissions(['Budgeting-Staffing-Fixed Read', 'Budgeting-Staffing-Fixed Write']))
        {
            await this.api_request()
        }
        else
        {
            window.location.href = '/'
        }
    }
}
</script>
